import {
  IsUUID,
  IsEnum,
  IsOptional,
  IsString,
  IsNumber,
  IsDateString,
  ValidateNested,
  Min,
} from 'class-validator';
import { Type } from 'class-transformer';

import {
  LeadsResponseInterface,
  LeadStatus,
} from '../../interface/leads/leads-response.interface';

import { MiniUsersDto } from '../users/users.dto';
import { ClientsDto } from '../clients/clients.dto';
import { Brand } from '../../utils/enums.utils';

export class LeadsDto implements LeadsResponseInterface {

  @IsUUID()
  id!: string;

  @IsEnum(Brand)
  brand!: Brand;

  @IsOptional()
  @IsString()
  description!: string | null;

  @IsOptional()
  @Type(() => Number)
  @IsNumber({ maxDecimalPlaces: 2 })
  @Min(0)
  estimated_amount!: number | null;

  @IsOptional()
  @IsDateString()
  target_date!: string | null;

  @IsEnum(LeadStatus)
  status!: LeadStatus;

  @IsOptional()
  @IsString()
  remarks!: string | null;

  @IsOptional()
  @IsString()
  brand_description!: string | null;

  @IsOptional()
  @IsDateString()
  created_at!: string | null;

  @IsOptional()
  @IsDateString()
  updated_at!: string | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  created_by!: MiniUsersDto | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  updated_by!: MiniUsersDto | null;

  @ValidateNested()
  @Type(() => ClientsDto)
  client!: ClientsDto;
}